import { useState } from "react";
import { useSetRecoilState } from "recoil";
import { userSimpleAtom } from "recoil/userSimpleAtom";
import { useNavigate } from "react-router-dom";
import {
  axiosInstancePromotion,
  CustomResponseFormat,
  setAuthHeadersPromotion,
} from "api/instancePromotion";
import { trackCapiStandardEvent } from "analytics/metaCapi";
import mixpanel from "mixpanel-browser";
import { PATH } from "../routes/paths";
import useMixpanelPromotionPeople from "./useMixpanelPromotionPeople";
import useMixpanelPromotion from "./useMixpanelPromotion";

export default function useLoginPromotion({
  url,
  idToken,
  type,
}: {
  url: string;
  idToken: string;
  type: "google" | "apple";
}) {
  let navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string>();
  const setUser = useSetRecoilState(userSimpleAtom);
  const setPromotionPeople = useMixpanelPromotionPeople();

  const trackPromotion = useMixpanelPromotion({
    eventName: "가입",
  });

  const login = async () => {
    if (isLoading) return;

    setIsLoading(true);
    setError(undefined);
    try {
      const response = await axiosInstancePromotion.post<CustomResponseFormat>(
        url,
        {
          idToken: idToken,
          type: type,
        }
      );

      if (response.code === 0) {
        const result = response.result;
        setAuthHeadersPromotion(result.accessToken);
        setUser(result);

        // Track CompleteRegistration event with userId and email
        trackCapiStandardEvent("CompleteRegistration", {
          externalId: result.userId,
          email: result.email,
        });

        // Mixpanel identify with trackId
        const promotionInstance = (mixpanel as any).promotion;
        if (promotionInstance && result.trackId) {
          promotionInstance.identify(result.trackId);

          trackPromotion();

          setPromotionPeople({
            $email: result.email,
            user_id: result.userId,
          });
        }

        // nickname이 있으면 결제 페이지로, 없으면 닉네임 입력 페이지로
        if (result.nickname) {
          navigate(PATH.promotionPayment, { replace: true });
        } else {
          navigate(PATH.promotionNicknameSubmit, { replace: true });
        }
      } else {
        setError("로그인에 실패했습니다. 다시 시도해주세요.");
        throw new Error(`Login failed with code: ${response.code}`);
      }
    } catch (error) {
      console.error("Login failed:", error);
      if (!error) {
        setError("로그인에 실패했습니다. 다시 시도해주세요.");
      }
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return { login, isLoading, error };
}
